import checkStatus from './checkStatus';
import createFetchOptions from './createFetchOptions';

const post = async <T>(endpoint: string, data = {}): Promise<T> => {
  const response = await fetch(`${__CONFIG__.apiUrl}${endpoint}`, createFetchOptions(data));
  return checkStatus<T>(response);
};

export default post;
